import { useState } from "react";
import { Grid } from "@material-ui/core";

import FormDatePicker from "../../shared/form-date-picker";
import EmailedReportPanel from "../emailed-report-panel";
import { StorageAreaSummaryReportProps } from "../../../interface/forms/StorageAreaSummaryReportProps";
import { formatDate } from "../../../utils/date-helper";

/**
 * The Small Quantities and Hydrovac summary reports: same form, same delivery, only the
 * endpoint differs. Everything about running one is EmailedReportPanel's job.
 */
const StorageAreaSummaryReportPanel = ({
  title,
  emptyMessage,
  send,
  onRunStateChange,
}: StorageAreaSummaryReportProps) => {
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);

  const period =
    fromDate && toDate
      ? `${formatDate(fromDate, false)} – ${formatDate(toDate, false)}`
      : "";

  return (
    <EmailedReportPanel
      title={title}
      emptyMessage={emptyMessage}
      canSend={!!fromDate && !!toDate}
      facts={period ? [{ label: "Period", value: period }] : []}
      send={(emails) => send(fromDate as Date, toDate as Date, emails)}
      onRunStateChange={onRunStateChange}
    >
      <Grid item xs={12} sm={6}>
        <FormDatePicker
          label="From Date"
          value={fromDate}
          onChange={(date: any) => setFromDate(date)}
          clearable
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormDatePicker
          label="To Date"
          value={toDate}
          onChange={(date: any) => setToDate(date)}
          clearable
        />
      </Grid>
    </EmailedReportPanel>
  );
};

export default StorageAreaSummaryReportPanel;
